import { render, staticRenderFns } from "./Grooves.vue?vue&type=template&id=671bc814&scoped=true"
import script from "./Grooves.vue?vue&type=script&lang=js"
export * from "./Grooves.vue?vue&type=script&lang=js"
import style0 from "./Grooves.vue?vue&type=style&index=0&id=671bc814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671bc814",
  null
  
)

export default component.exports